import React, { Component } from 'react';
import { Col, Card, CardBody, Row, Button, Label, CardFooter, Form, FormGroup, Input } from 'reactstrap';
import withAuth from '../../components/Services/WithAuth';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { getMisTeam, fetchMisTeamById, updateMisTeam, fetchMisFields, fetchDefaultMisFields } from './action.js'
import './style.css'
import { Preloading } from '../../components/UI/Preloader/action';
import CorporateModal from '../../components/UI/CorporateModal/index';
import MultiSelect from '../../components/ReusableComponents/MultiSelect/index';
class MisTeamComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            teamsList: [],
            selectedMisTeamObj: '',
            misTeamForUpdate: null,
            selectedMisFieldNames: [],
            misFieldList: [],
            defaultMisFieldList: [],
            tempSelectedMisFields: [],
            showCorporateModal: false,
            corporateModalType: "",
            associatedUserRoles: [],
            showAssociatedTeamRoles: false,
            showAssociatedMisField: false,
        }
    }
    componentDidMount() {
        if (!this.props.misTeamListSuccess || this.props.misTeamListSuccess.length === 0) {
            this.props.getMisTeam();
        }
        else if (!this.state.teamsList || this.state.teamsList.length === 0) {
            let tmpArr = this.convertMisTeamsForSelectDropDown(this.props.misTeamListSuccess);
            this.setState({ teamsList: tmpArr });
        }
        if (!this.props.misFieldList || this.props.misFieldList.length === 0) {
            this.props.fetchMisFieldList();
        }
        if (!this.props.defaultMisFieldList || this.props.defaultMisFieldList.length == 0) {
            this.props.fetchDefaultMisFields();
        }
    }

    componentDidUpdate(prevProps) {

        if (this.props.misTeamListSuccess && this.props.misTeamListSuccess !== prevProps.misTeamListSuccess) {
            let tmpArr = this.convertMisTeamsForSelectDropDown(this.props.misTeamListSuccess);
            this.setState({ teamsList: tmpArr });
        }

        if (this.props.fetchMisTeamByIdSuccess && this.props.fetchMisTeamByIdSuccess !== prevProps.fetchMisTeamByIdSuccess) {
            let tmpArr = [];
            let tmpRoleArr = [];
            if (this.props.fetchMisTeamByIdSuccess.associatedFieldNames && this.props.fetchMisTeamByIdSuccess.associatedFieldNames.length > 0) {
                for (let fieldName of this.props.fetchMisTeamByIdSuccess.associatedFieldNames) {
                    if (fieldName)
                        tmpArr.push(fieldName);
                }
            }
            if (this.props.fetchMisTeamByIdSuccess.associatedTeamRoles && this.props.fetchMisTeamByIdSuccess.associatedTeamRoles.length > 0) {

                for (let associatedRole of this.props.fetchMisTeamByIdSuccess.associatedTeamRoles) {
                    if (associatedRole)
                        tmpRoleArr.push(associatedRole);
                }

            }

            this.setState({
                misTeamForUpdate: this.props.fetchMisTeamByIdSuccess,
                selectedMisFieldNames: tmpArr,
                associatedUserRoles: tmpRoleArr
            })
            this.props.preloading(false);
        }

        if (this.props.fetchMisTeamByIdFailure && this.props.fetchMisTeamByIdFailure !== prevProps.fetchMisTeamByIdFailure) {
            this.props.preloading(false);
            this.setState({ selectedMisFieldNames: [] })
            this.displayErrorMessage("Failed to Fetch Selected Team Details!!!")
        }

        if (this.props.misFieldList && this.props.misFieldList !== prevProps.misFieldList) {
            let tmpArr = []
            for (let fieldName of this.props.misFieldList) {
                if (fieldName)
                    tmpArr.push(fieldName);
            }
            this.setState({ misFieldList: tmpArr })
        }

        if (this.props.defaultMisFieldList && this.props.defaultMisFieldList !== prevProps.defaultMisFieldList) {
            let tmpArr = []
            for (let fieldName of this.props.defaultMisFieldList) {
                if (fieldName)
                    tmpArr.push(fieldName);
            }
            this.setState({ defaultMisFieldList: tmpArr })
        }

        if (this.props.updateMisTeamSuccess && this.props.updateMisTeamSuccess !== prevProps.updateMisTeamSuccess) {
            this.props.preloading(false);
            let temaName = this.state.misTeamForUpdate && this.state.misTeamForUpdate.teamName ? this.state.misTeamForUpdate.teamName : '';
            let message = `Updated Mis Team ${temaName} Configuration Successfully`
            this.displaySuccessMessage(message);
            this.reset()
        }

        if (this.props.updateMisTeamFailure && this.props.updateMisTeamFailure !== prevProps.updateMisTeamFailure) {
            this.props.preloading(false);
            let temaName = this.state.misTeamForUpdate && this.state.misTeamForUpdate.teamName ? this.state.misTeamForUpdate.teamName : '';
            let message = `Mis Team ${temaName} Configuration Updation Failed`
            this.displayErrorMessage(message);
            this.reset()
        }

    }

    convertMisTeamsForSelectDropDown = (misTeamList) => {
        let tmpArr = [];
        if (misTeamList && misTeamList.length !== 0) {
            misTeamList.forEach(data => {
                if (data && data.teamName && data.teamId) {
                    let obj = { value: data.teamId, label: data.teamName }
                    tmpArr.push(obj)
                }
            });
        }
        return tmpArr;
    }

    displayErrorMessage = (message) => {
        toast.error(
            <div>
                <i className="fa fa-exclamation-triangle"></i> {message}
            </div>
        );

    }

    displayWarnMessage = (message) => {
        toast.warn(
            <div>
                <i className="fa fa-exclamation-triangle"></i> {message}
            </div>
        );

    }

    displaySuccessMessage = (message) => {
        toast.success(
            <div>
                {message}
            </div>
        );

    }

    reset = () => {
        this.setState({
            selectedMisTeamObj: '',
            misTeamForUpdate: null,
            selectedMisFieldNames: [],
            tempSelectedMisFields: [],
            showCorporateModal: false,
            associatedUserRoles: [],
            showAssociatedTeamRoles: false,
            showAssociatedMisField: false,
        })
    }

    handleMisTeamChange = (selectedMisTeam) => {
        this.setState({ selectedMisTeamObj: selectedMisTeam })
        if (selectedMisTeam && selectedMisTeam.value) {
            this.setState({
                misTeamForUpdate: null,
                selectedMisFieldNames: [],
                tempSelectedMisFields: [],
                showCorporateModal: false,
                associatedUserRoles: [],
            })
            this.props.preloading(true);
            this.props.fetchMisTeamById(selectedMisTeam.value);
        }
        else {
            this.reset();
        }
    }

    handleUpdate = () => {
        if (!this.state.misTeamForUpdate || !this.state.selectedMisFieldNames || this.state.selectedMisFieldNames.length === 0) {
            this.displayWarnMessage("Please Select Mis Fields");
        } else {
            const updatedMisTeamForUpdate = {
                ...this.state.misTeamForUpdate,
                associatedFieldNames: this.state.selectedMisFieldNames
            };
    
            this.setState({ misTeamForUpdate: updatedMisTeamForUpdate }, () => {
                this.props.preloading(true);
                this.props.updateMisTeam(this.state.misTeamForUpdate);
            });
        }
    }    

    getListStyle = () => ({
        background: "lightblue",
        padding: 5,
        width: 550,
        height: 300,
        overflowY: 'scroll'
    });

    getListStyleForRoles = () => ({
        background: "lightblue",
        padding: 5,
        width: 550,
        height: 200,
        overflowY: 'scroll'
    });

    getItemStyle = () => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: 10,
        margin: 5,
        width: 440,
        border: "groove",
        // change background colour if dragging
        background: "lightgray",

    });

    handleDelete = (event, misFieldNameToDelete) => {
        const tempArr = Array.from(this.state.selectedMisFieldNames);
        const index = tempArr.indexOf(misFieldNameToDelete);
        if (index > -1) {
            tempArr.splice(index, 1);
            this.setState({
                selectedMisFieldNames: tempArr
            })
        }
    }

    handleAddDefaultMisFields = () => {
        if (this.state.defaultMisFieldList && this.state.defaultMisFieldList.length > 0) {
            var tmp = this.state.selectedMisFieldNames ? this.state.selectedMisFieldNames : [];
            for (let i = 0; i < this.state.defaultMisFieldList.length; i++) {
                if (this.state.defaultMisFieldList[i] && this.state.defaultMisFieldList[i].name && !tmp.includes(this.state.defaultMisFieldList[i].name)) {
                    tmp.push(this.state.defaultMisFieldList[i].name);
                }
            }
            this.setState({
                selectedMisFieldNames: tmp
            })
        }
    }

    getDeleteButtonStyle = () => ({
        float: 'right'
    })



    selectedEntityCallbackForMisFieldAddition = (selectedMisData) => {
        this.setState({
            tempSelectedMisFields: selectedMisData
        })
    }

    handleAdd = () => {
        this.handleToggle();
    }


    handleToggle = () => {
        this.setState(prevState => ({
            showCorporateModal: !prevState.showCorporateModal,
            tempSelectedMisFields: []
        }))
    }
    handleCancel = () => {
        this.handleToggle();
    }

    handleAddMisFields = () => {
        if (this.state.tempSelectedMisFields.length == 0) {
            return;
        }
        for (let i = 0; i < this.state.tempSelectedMisFields.length; i++) {
            if (!this.state.selectedMisFieldNames.includes(this.state.tempSelectedMisFields[i].label)) {
                this.state.selectedMisFieldNames.push(this.state.tempSelectedMisFields[i].label);
            }
        }
        this.handleToggle();
    }
    toggleMisTeam = () => {
        this.setState((prevState) => ({
            showAssociatedTeamRoles: !prevState.showAssociatedTeamRoles,
        }))
    }
    toggleMisField = () => {
        this.setState((prevState) => ({
            showAssociatedMisField: !prevState.showAssociatedMisField,
        }))
    }
    render() {
        return (
            <Col>
                <Row>
                    <Col sm='22' className="d-flex justify-content-between align-items-center mb-3">
                        <h5>Mis Team Configurations</h5>
                    </Col>
                </Row>
                <Form>
                    <FormGroup className="mb-4">

                        <Label clasfor="selectedTeam" className="font-weight-bold">Mis Team <span className='text-danger'>*</span></Label>
                        <Select value={this.state.selectedMisTeamObj} onChange={this.handleMisTeamChange} options={this.state.teamsList} isClearable={true} />
                    </FormGroup>
                    {this.state.misTeamForUpdate ?
                        <div>
                            <FormGroup>
                                <Button onClick={this.toggleMisTeam} outline className="d-block p-2 collapse-bar" >
                                    <span className='font-weight-bold collapse-bar-text'>Mis Team Roles <span className='text-danger'>*</span></span>
                                    <i className={this.state.showAssociatedTeamRoles ? "icon-arrow-up collapse-bar-icon" : "icon-arrow-down collapse-bar-icon"}></i>
                                </Button>&nbsp;&nbsp;
                                {this.state.showAssociatedTeamRoles ?
                                    <div style={this.getListStyleForRoles()} >
                                        {
                                            this.state.associatedUserRoles.map((item, index) => (
                                                <div key={index}>
                                                    <div className="card" style={this.getItemStyle()}>
                                                        <div className="flex-display">
                                                            <span className='text-primary font-weight-bold'>{item}</span>
                                                        </div>
                                                    </div>
                                                </div>))
                                        }
                                    </div> :
                                    null}

                            </FormGroup>

                            <FormGroup>
                                <Button onClick={this.toggleMisField} outline className="d-block p-2 collapse-bar" >
                                    <span className='font-weight-bold collapse-bar-text'>Mis Form Field <span className='text-danger'>*</span></span>
                                    <i className={this.state.showAssociatedMisField ? "icon-arrow-up collapse-bar-icon" : "icon-arrow-down collapse-bar-icon"}></i>
                                </Button>&nbsp;&nbsp;
                                {this.state.showAssociatedMisField ?
                                    <div>
                                        <div className="header-blue d-block p-2 text-primary font-weight-bold">
                                            <Label>Choose Mis Form Fields &nbsp;&nbsp;
                                                <Button className="mx-1" size="sm" outline color="primary" title="Add" id="add" onClick={this.handleAdd}>
                                                    <i className="icon-plus"></i>Add
                                                </Button>
                                            </Label>&nbsp;&nbsp;&nbsp;&nbsp;
                                            <Button size="sm" outline color="primary" title="AddDefaultMisFields" id="addDefaultMisFields" onClick={this.handleAddDefaultMisFields}>
                                                <i className="icon-plus"></i>Add Default MIS Fields
                                            </Button>
                                        </div>
                                        <div>
                                            <Label className="header-blue d-block p-2 text-primary font-weight-bold">Selected Mis Form Fields</Label>
                                        </div>
                                        <div style={this.getListStyle()} >
                                            {
                                                this.state.selectedMisFieldNames.map((item, index) => (
                                                    <div key={index}>
                                                        <div className="card" style={this.getItemStyle()}>
                                                            <div className="flex-display">
                                                                <span className='text-primary font-weight-bold'>{item}</span>
                                                                <Button style={this.getDeleteButtonStyle()} title="Remove" id="remove" className="float right justify-content-between align-items-center" color="danger" icon="fa-solid fa-arrow-right-to-bracket" onClick={e => this.handleDelete(e, item)} value={item}>
                                                                    <i className="icon-delete"></i>
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>))
                                            }
                                        </div>
                                    </div> : null}
                            </FormGroup>
                            <FormGroup>
                                <div>
                                    <CorporateModal toShow={this.state.showCorporateModal} modalClosed={this.handleToggle} modalType={this.state.corporateModalType}
                                        body={<Form >
                                            <Row>
                                                <Col >
                                                    <FormGroup>
                                                        <Label>Choose Mis Fields</Label>
                                                        <MultiSelect data={this.state.misFieldList} selected={this.selectedEntityCallbackForMisFieldAddition} selectedValue={this.state.tempSelectedMisFields} />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Button className="btn btn-primary mt-3" onClick={this.handleAddMisFields} >Add</Button>
                                                        <Button className="btn btn-danger mt-3 ml-3" onClick={this.handleCancel} >cancel</Button>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Form>}
                                    />
                                </div>
                            </FormGroup>

                            <FormGroup className="mb-4">
                                <Button color="primary" className="mr-4" onClick={this.handleUpdate}>Update</Button>
                                <Button color="info" onClick={this.reset}>Reset</Button>
                            </FormGroup>
                        </div> : null}
                </Form>

            </Col>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    misTeamListSuccess: state.misTeamReducer.misTeamListSuccess,
    misTeamListFailure: state.misTeamReducer.misTeamListFailure,
    fetchMisTeamByIdSuccess: state.misTeamReducer.fetchMisTeamByIdSuccess,
    fetchMisTeamByIdFailure: state.misTeamReducer.fetchMisTeamByIdFailure,
    updateMisTeamSuccess: state.misTeamReducer.updateMisTeamSuccess,
    updateMisTeamFailure: state.misTeamReducer.updateMisTeamFailure,
    misFieldList: state.misTeamReducer.fetchMisFieldListSuccess,
    defaultMisFieldList: state.misTeamReducer.fetchDefaultMisFieldListSuccess,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    getMisTeam: () => { dispatch(getMisTeam()) },
    fetchMisTeamById: (data) => { dispatch(fetchMisTeamById(data)) },
    updateMisTeam: (data) => { dispatch(updateMisTeam(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    fetchDefaultMisFields: () => { dispatch(fetchDefaultMisFields()) },
    fetchMisFieldList: () => { dispatch(fetchMisFields()) },
})


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(MisTeamComponent));
